import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { get_all_credit_notes } from "../../../../Controllers/Sales/CreditNotes";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Sales/CreditNote/tables";
import headers from "../../../../Data/Tables/Sales/CreditNote/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import ActionButton from "../../../../Componets/Buttons/action";

const CreditNotesTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    fetchData({
      ...data,
      currentPage: data?.currentPage || 1,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
    });
  };

  const actiondata = (data) => {
    fetchData({
      currentPage: pagination?.currentPage,
    });
  };

  const fetchData = async (tabledata = {}) => {
    try {
      setLoader(true);
      const data = {
        search: tabledata?.search,
        customer: tabledata?.customer,
        date: tabledata?.date,
        page: tabledata?.currentPage,
      };

      const creditNotes = await get_all_credit_notes(data);
      if (creditNotes?.status) {
        let tableData = [];
        creditNotes?.data?.data?.map((value, index) => {
          tableData?.push({
            path: `/app/sales/invoices/view/${value?.invoice?._id}`,
            Number: `#CN-${value?.number}`,
            Invoice: value?.invoice?.number ? `#INV-${value?.invoice?.number}` : "-",
            Customer: value?.customer?.name || "Walk-in-customer",
            Date: moment(value?.date).format("MMMM Do YYYY"),
            Reason: value?.reason,
            Total: value?.total?.toFixed(3),
            "Created By": value?.created_by?.name,
            Action: (
              <ActionButton
                view={`/app/sales/credit-notes/view/${value?._id}`}
                id={value?._id}
                api="delete-credit-note"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: creditNotes?.data?.currentPage,
          totalCount: creditNotes?.data?.totalCount,
          totalPages: creditNotes?.data?.totalPages,
        });

        setBody(tableData);
        setLoader(false);
      } else {
        toast?.error(creditNotes?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default CreditNotesTable;